import React from "react";

const CompletedTxn = () => {
  return (
    <div className="bg-white p-4 shadow-md rounded-lg">
      <h2 className="text-2xl font-semibold mb-4">Transaction Completed</h2>
      <p className="text-gray-700">
        Your transaction has been successfully completed.
      </p>
    </div>
  );
};

export default CompletedTxn;
